import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    if (state) {
      Object.assign(state, state.getDefaultState());
    }
  },
  setLoading: set("loading"),
  setQualifications: set("qualifications"),
  setAutoQualification: set("auto_qualification"),
  setQualificationsUnresolved: set("qualificationsUnresolved"),
  pushQualification(state, data) {
    state.qualifications.push(data);
  },
  spliceQualifications(state, { index, data }) {
    state.qualifications.splice(index, 1, data);
  },
};
